export type LocaleConfig = Set<string>

const localeConfig: LocaleConfig = new Set(["fr_FR", "en_US", "nl_NL", "fr_FR_CSE"]);

export default localeConfig;
